<template>
  <component v-if="setbrandid && YourDetailsComponent" :is="YourDetailsComponent"/>
  <!-- <YourDetailsDefault v-else-if="setbrandid" /> -->
</template>

<script>
import { markRaw } from "vue";
const axios = require("axios");
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
const crypto = require("crypto");
console.info(crypto);

// import YourDetailsDefault from "./YourDetailsDefault.vue";

export default {
  name: "App",
  components: {
    //YourDetailsDefault,
  },
  data() {
    return {
      setbrandid: "",
      YourDetailsComponent: null,
      use_newflow: false,
    };
  },
  methods: {
    async getAmendComponent() {

      let module;
      let brand = this.setbrandid;
      if (brand === "BH1") {
        brand = "BHX";
      }

      if (brand === "AIR" || brand === "LAX" || brand === "GSO") {
        module = await import(`../YourDetails/YourDetails${brand}New.vue`);
      } else {
        module = await import(`../YourDetails/YourDetails${brand}.vue`);
      }

      this.YourDetailsComponent = markRaw(module.default);
    },
    getbranded() {
      axios
        .post(
          encryptStorage.getItem("rez_dev_k").VUE_APP_DOMAIN_DEVHUB +
            "hubapmydbauth/brandapi/getbrnslg_dev.php",
          "",
          {
            headers: {
              secret_id: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETID,
              secret_key: encryptStorage.getItem("rez_dev_k").VUE_APP_BRNDED_SECRETKEY,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data.code == "1") {
            this.setbrandid = response.data.slug;
            this.getAmendComponent();
          }
        });
    },
    async get_rez_data_k()
    {
      if (typeof encryptStorage.getItem("rez_dev_k") === "undefined") 
      {
        let _this = this;
        await axios.get('https://devhub.rezcomm.com/hubapmydbauth/livedata/index.php')
        .then(response => {

        const key = 'XwB?au@qy*^y!r6R&wV8fVuSXmGKf3Sn';
        const encryptedData = response.data;
        let dec = _this.decrypt_custom(key, encryptedData);
        
        encryptStorage.setItem("rez_dev_k",dec);
        
             
        })
        .then(() => {
          _this.getbranded();
        }
        )
        .catch(error => {
        console.error(error);
        });
        }
        else
        {
          this.getbranded();
        }
    },
    decrypt_custom(key, data) {
      
      const decodedData = Buffer.from(data, 'base64').toString('utf8');
        const parts = decodedData.split('::');
    
        // Extract IV
        key = Buffer.from(parts[0]);
        let iv = Buffer.from(parts[2], 'hex');
    
        // Extract encrypted data
        const encryptedData = Buffer.from(parts[1], 'base64');
    
        // Create decipher object with correct IV and key
        const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv);
    
        // Update decryption with encrypted data
        let decrypted = decipher.update(encryptedData);
    
        // Finalize the decryption
        decrypted = Buffer.concat([decrypted, decipher.final()]);
    
        return decrypted.toString('utf8');
}    
  },
  beforeMount() {
    this.get_rez_data_k();
  },
  mounted() {
    // Remove the loader once Vue is initialized
    const loader = document.getElementById('loader');
    if (loader) {
      loader.parentNode.removeChild(loader);
    }
  },
};
</script>
